<template>
  <div class="view">
    <div class="flex items-center space-x-6 mb-4 pt-13">
      <p
        v-for="country in countries"
        :key="country.code"
        class="nav-item m-0 text-2xl font-bold text-black cursor-pointer"
        :class="{
          'opacity-30': activeCountry !== country.code
        }"
        @click="activeCountry = country.code"
      >
        {{ country.name }}
      </p>
    </div>

    <div class="flex items-center space-x-6 mb-4">
      <p
        v-for="lang in langs"
        :key="lang.code"
        class="nav-item m-0 text-xl font-bold text-black cursor-pointer"
        :class="{
          'opacity-30': activeLang !== lang.code
        }"
        @click="activeLang = lang.code"
      >
        {{ lang.name }}
      </p>
    </div>

    <div class="stories">
      <router-link to="/stories/new" class="story new"> Создать </router-link>

      <div
        v-if="fetchStories.isPending"
        class="w-30 h-30 flex items-center justify-center"
      >
        <uiLoader />
      </div>

      <template v-else>
        <router-link
          v-for="story in stories"
          :key="story.id"
          :to="'/stories/' + story.id"
          class="story"
        >
          <img :src="story.cover" />
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import api from '@/utils/ky'
import { useCountries } from '@/composables/countries'
import { useStorage } from '@vueuse/core'
import { useAsyncMethod } from '@/utils/async-methods'

export default {
  name: 'StoriesPage',
  setup () {
    const { countries } = useCountries()
    const activeCountry = useStorage('activeCountry', countries.value[0].code)

    const { langs } = useCountries({ activeCountry })
    const activeLang = useStorage('activeLang', langs.value[0].code)

    const stories = ref([])

    const fetchStories = useAsyncMethod(async () => {
      const lang = activeLang.value
      const country = activeCountry.value
      const { data } = await api.get(`admin/stories/${country}/${lang}`)
      stories.value = data
    })

    onMounted(async () => await fetchStories())
    watch(activeCountry, async () => {
      activeLang.value = ''
      activeLang.value = langs.value[0].code
      await fetchStories()
    })
    watch(activeLang, async () => await fetchStories())

    return {
      stories,
      countries,
      langs,
      activeLang,
      activeCountry,
      fetchStories
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
  width: 100%;
  max-width: 600px;
  padding-top: 50px;
  margin: 0 auto;
}

.stories {
  height: auto;
  display: flex;
  flex-wrap: wrap;

  .story {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: @grey;
    overflow: hidden;
    margin: 10px;
    flex-shrink: 0;

    img {
      width: 100%;
    }
  }

  .new {
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
}
</style>
